import { keyframes } from '@emotion/core';
import { useDimensions } from '@zapier/design-system/dist/hooks';
import { Animation, Colors, Shadows, Typography, } from '@zapier/design-system/dist/theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/common-utils';
const distance = '5px';
const tooltipOpenAnimation = keyframes({
    '0%': {
        opacity: 0,
    },
    '100%': {
        opacity: 1,
    },
});
const positionStyles = {
    northwest: {
        bottom: `calc(100% + ${distance})`,
        left: 0,
    },
    north: {
        bottom: `calc(100% + ${distance})`,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    northeast: {
        bottom: `calc(100% + ${distance})`,
        right: 0,
    },
    east: {
        left: `calc(100% + ${distance})`,
        top: '50%',
        transform: 'translateY(-50%)',
    },
    southeast: {
        top: `calc(100% + ${distance})`,
        right: 0,
    },
    south: {
        top: `calc(100% + ${distance})`,
        left: '50%',
        transform: 'translateX(-50%)',
    },
    southwest: {
        top: `calc(100% + ${distance})`,
        left: 0,
    },
    west: {
        right: `calc(100% + ${distance})`,
        top: '50%',
        transform: 'translateY(-50%)',
    },
};
const singleLineHeight = 20;
const defaultPosition = 'south';
const Styles = labelStyles(__filename, {
    root: ({ position = defaultPosition, allowMultiline, isInteractive }, isMultiline) => [
        Object.assign(Object.assign({ color: Colors.white, textAlign: 'center', borderRadius: 100, position: 'absolute', padding: '0 1em', zIndex: 2, boxShadow: Shadows.elevation5, backgroundColor: Colors.grey900, maxWidth: 300, animation: `${Animation.transitionDuration} ${Animation.transitionTimingFunction} ${tooltipOpenAnimation}` }, Typography.altText900), { fontWeight: 600, '&::before': {
                content: '""',
                position: 'absolute',
                top: `-${distance}`,
                right: `-${distance}`,
                bottom: `-${distance}`,
                left: `-${distance}`,
                zIndex: -1,
            } }),
        withModifier(position, positionStyles[position]),
        isMultiline &&
            withModifier('isMultiline', {
                borderRadius: 10,
                padding: '10px 15px 15px 15px',
                textAlign: 'left',
            }),
        !allowMultiline &&
            withModifier('singleLine', {
                height: singleLineHeight,
            }),
        !isInteractive &&
            withModifier('nonInteractive', {
                pointerEvents: 'none',
            }),
    ],
    content: (props) => [
        {
            display: 'block',
        },
        !props.allowMultiline &&
            withModifier('singleLine', {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
            }),
    ],
});
export const Tooltip = (props) => {
    const [ref, { height }] = useDimensions();
    const isMultiline = height > singleLineHeight;
    return (isolateComponent("span", { "aria-hidden": props.ariaHidden, css: Styles.root(props, isMultiline), "data-testid": `tooltip-${props.position}`, id: props.id, ref: ref, role: "tooltip" },
        isolateComponent("span", { css: Styles.content(props) }, props.children)));
};
Tooltip.defaultProps = {
    allowMultiline: false,
    position: defaultPosition,
};
//# sourceMappingURL=Tooltip.js.map
